'use client';

import { useCallback } from 'react';
import type { OnDataOptions } from '@apollo/client';
import { isServer } from '@frameio/utils/config/helpers';
import { useQuickBugReportTrigger } from '../../hooks/useQuickBugReportTrigger';
import type { FeedbackButtonTriggeredSubscription } from '../gql';
import {
  useFeedbackButtonTriggeredSubscription,
  useOpenInBrowserMutation,
} from '../gql';

/**
 * sends FCI jira template url to UXP host when requested
 */
export function UXPFeedbackButtonSubscription() {
  const { getJiraIssueTemplateUrl } = useQuickBugReportTrigger();
  const [openInBrowser] = useOpenInBrowserMutation({
    context: { resolveWithUXP: true },
  });

  const onData = useCallback(
    (options: OnDataOptions<FeedbackButtonTriggeredSubscription>) => {
      const payload = options?.data.data?.feedbackButtonTriggered || '';
      const buildInfoParams = JSON.parse(payload);
      const opts = { buildInfoParams, jiraProjectId: '10265' } as const;
      const url = getJiraIssueTemplateUrl(opts);
      openInBrowser({ variables: { input: { url } } });
    },
    [getJiraIssueTemplateUrl, openInBrowser]
  );

  useFeedbackButtonTriggeredSubscription({
    skip: isServer,
    context: { resolveWithUXP: true },
    onData,
  });

  return null;
}
